import { Box, Container, Flex, Link, Text, useSlotRecipe, VStack } from '@chakra-ui/react';

import { dateHelpers } from '@nocowanie/core';

import { SocialMedia } from '@app/components/molecules/social-media';

import { FooterProps } from './footer.props';
import menuLinks from './menu-links.json';
import { staticLinks } from './static-links-data';

export const Footer = ({ ...rest }: FooterProps) => {
    const recipe = useSlotRecipe({ key: 'footer' });
    const styles = recipe();

    return (
        <Box as={'footer'} css={styles.wrapper} {...rest}>
            <Container css={styles.container}>
                <SocialMedia hideFrom="md" mb={9} />
                <Flex gap={2}>
                    <Box
                        w="full"
                        css={{
                            columnCount: { base: 1, md: 3 },
                        }}
                    >
                        {menuLinks.map((link, index) => (
                            <VStack key={index} mb={4} alignItems={'flex-start'}>
                                <Link
                                    href={link.url}
                                    target={link.target ?? '_self'}
                                    variant={'plain'}
                                    css={styles.link}
                                >
                                    {link.label}
                                </Link>
                            </VStack>
                        ))}
                    </Box>
                    <SocialMedia hideBelow="md" w={'25%'} />
                </Flex>
                <Flex
                    direction={'column'}
                    justifyContent={'center'}
                    fontSize={'sm'}
                    mt={{
                        base: 4,
                        md: 12,
                    }}
                    gap={8}
                >
                    <Flex flexWrap={'wrap'} gap={1}>
                        {staticLinks.map((link, index) => (
                            <Box key={index}>
                                <Link href={link.url} css={styles.link} variant={'plain'}>
                                    {link.label}
                                </Link>
                                {index < staticLinks.length - 1 ? ',' : null}
                            </Box>
                        ))}
                    </Flex>
                    <Text>
                        Copyright 2005-{dateHelpers.format(new Date(), 'yyyy')}{' '}
                        <Box as="br" hideFrom={'md'} />
                        by NOCOWANIE.PL Sp. z o.o.
                    </Text>
                </Flex>
            </Container>
        </Box>
    );
};
